import {
  FETCH_WEBHOOK_CONFIG,
  CREATE_WEBHOOK_CONFIG,
  UPDATE_WEBHOOK_CONFIG,
  DELETE_WEBHOOK_CONFIG,
  SET_WEBHOOK_LOADING,
  SET_WEBHOOK_ERROR
} from '../Actions/AI/type';

const initialState = {
  loading: false,
  error: null,
  config: null
};

const aiwebhookReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WEBHOOK_LOADING:
      return { ...state, loading: true };

    case SET_WEBHOOK_ERROR:
      return { ...state, loading: false, error: action.payload };

    case FETCH_WEBHOOK_CONFIG:
    case CREATE_WEBHOOK_CONFIG:
    case UPDATE_WEBHOOK_CONFIG:
      return { ...state, loading: false, error: null, config: action.payload };

    case DELETE_WEBHOOK_CONFIG:
      return { ...state, loading: false, error: null, config: null };

    default:
      return state;
  }
};

export default aiwebhookReducer;
